"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.useIncentive = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _actions = require("../actions");

var _constants = require("../constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useIncentive = function useIncentive(productType) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var state = (0, _reactRedux.useSelector)(function (state) {
    return state[_constants.INCENTIVE_REDUCER];
  });

  var _useMemo = (0, _react.useMemo)(function () {
    return (0, _redux.bindActionCreators)(_actions.incentiveActions, dispatch);
  }, [dispatch]),
      setPreOpen = _useMemo.setPreOpen,
      setOpen = _useMemo.setOpen,
      getStatus = _useMemo.getStatus,
      verify = _useMemo.verify,
      referral = _useMemo.referral,
      cacheReferrerEmail = _useMemo.cacheReferrerEmail;

  return _objectSpread(_objectSpread({}, state), {}, {
    incentiveSetPreOpen: (0, _react.useCallback)(function (incentiveUuid) {
      return setPreOpen(incentiveUuid, productType);
    }, [setPreOpen, productType]),
    incentiveSetOpen: (0, _react.useCallback)(function (incentiveUuid, applicationUuid, referrerEmail, incentiveCode, dispatchHttpActions) {
      return setOpen(incentiveUuid, applicationUuid, referrerEmail, incentiveCode, productType, dispatchHttpActions);
    }, [setOpen, productType]),
    incentiveGetStatus: (0, _react.useCallback)(function (dispatchHttpActions) {
      return getStatus(productType, dispatchHttpActions);
    }, [getStatus, productType]),
    incentiveVerify: (0, _react.useCallback)(function (incentiveUuid, incentiveCode, dispatchHttpActions) {
      return verify(incentiveUuid, incentiveCode, dispatchHttpActions);
    }, [verify]),
    incentiveReferral: (0, _react.useCallback)(function (incentiveUuid, email, dispatchHttpActions) {
      return referral(incentiveUuid, email, dispatchHttpActions);
    }, [referral]),
    incentiveCacheReferrerEmail: (0, _react.useCallback)(function (referrerEmail) {
      return cacheReferrerEmail(referrerEmail);
    }, [cacheReferrerEmail])
  });
};

exports.useIncentive = useIncentive;
var _default = useIncentive;
exports["default"] = _default;